export default __webpack_public_path__ + "static/targetPeopleImage-7406897fad220602db9f8cf2e6e787ce.png";